import { factory, getterOptions } from '@store/utils'
import { prop } from 'rambda'

export const ARTICLE_STATUS = {
  DRAFT: 'DRAFT',
  READY_FOR_REVIEW: 'READY_FOR_REVIEW',
  POSTED: 'POSTED',
}

export const ARTICLE_MODIFIERS = {
  SHALLOW: 'SHALLOW',
  EXTENSIVE: 'EXTENSIVE',
}

export const ARTICLE_TYPES = {
  ANSWER: 'ANSWER',
  BUYING_GUIDE: 'BUYING_GUIDE',
}

export default {
  auto: '*',

  store: {
    state: {
      categories: [
        { label: 'Activity', value: 'ACTIVITY' },
        { label: 'Application', value: 'APPLICATION' },
        { label: 'Brand', value: 'BRAND' },
        { label: 'Course', value: 'COURSE' },
        { label: 'Game', value: 'GAME' },
        { label: 'Profession', value: 'PROFESSION' },
        { label: 'Trait', value: 'TRAIT' },
      ],
      modifiers: [
        {
          label: 'Shallow',
          value: ARTICLE_MODIFIERS.SHALLOW,
        },
        {
          label: 'Extensive',
          value: ARTICLE_MODIFIERS.EXTENSIVE,
        },
      ],
      statuses: [
        {
          label: 'Draft',
          value: ARTICLE_STATUS.DRAFT,
          theme: 'neutral',
        },
        {
          label: 'Ready for review',
          value: ARTICLE_STATUS.READY_FOR_REVIEW,
          theme: 'warning',
        },
        {
          label: 'Posted',
          value: ARTICLE_STATUS.POSTED,
          theme: 'success',
        },
      ],
      types: [
        {
          label: 'Answer',
          value: ARTICLE_TYPES.ANSWER,
        },
        {
          label: 'Buying guide',
          value: ARTICLE_TYPES.BUYING_GUIDE,
        },
      ],
      isSavingArticle: false,
    },

    getters: {
      articleModifiers: prop('modifiers'),
      articleStatuses: prop('statuses'),
      articleTypes: prop('types'),
      categories: prop('categories'),

      articleModifiersOptions: getterOptions('articleModifiers', {
        value: null,
        label: 'None',
      }),

      articleTypeOptions: getterOptions('articleTypes', null),

      articleFactory: factory(({ authUser, queryOne }) => ({
        userId: authUser?.id || null,
        title: '',
        topic: null,
        status: 'DRAFT',
        category: 'GAME',
        type: ARTICLE_TYPES.BUYING_GUIDE,
        imageFileId: null,
        siteId: queryOne('site')?.id || null,
        spreadsheetUrl: null,
        spreadsheetParagraph: null,
        url: null,
        slug: null,
        archArticleId: null,
        remoteArticleId: null,
        sections: [],
        facts: [],
        criteria: {
          buckets: getRandomBuckets()
            .map(price => ({ price, limit: 3 })),
          minimalScores: {
            batteryScore: -2,
            bonusScore: -2,
            computingScore: -2,
            graphicsScore: -2,
            memoryScore: -2,
            keyboardScore: -2,
            portsScore: -2,
            reviewScore: -2,
            screenQualityScore: -2,
            screenScore: -2,
            storageScore: -2,
            weightScore: -2,
          },
          weights: {
            battery: 2,
            bonus: 2,
            cpu: 2,
            graphics: 2,
            memory: 2,
            ports: 2,
            resolution: 2,
            screen: 2,
            storageNvme: 2,
            storageSpace: 2,
            storageSsd: 2,
            weight: 2,
          },
        },
        // outro: [
        //   '# Table of Best Laptops for {topic}',
        //   '[sumtable]',
        // ].join('\n'),
      })),

      isSavingArticle: prop('isSavingArticle'),
    },

    actions: {
      SET_IS_SAVING_ARTICLE({ commit }, isSavingArticle) {
        commit('SET_IS_SAVING_ARTICLE', isSavingArticle)
      },
    },

    mutations: {
      SET_IS_SAVING_ARTICLE(state, isSavingArticle) {
        state.isSavingArticle = isSavingArticle
      },
    },
  },
}

const getRandomBuckets = (() => {
  const buckets = [
    [750, 1250, 1500, 2000, 4000, 10000],
    [750, 1000, 1250, 1500, 2000, 4000, 5000],
    [800, 1500, 2000, 5000],
    [900, 1200, 1600, 2000, 10000],
    [1000, 1500, 3000, 5000],
    [1000, 1500, 2000, 3000, 4000],
    [1000, 1500, 2000, 3000, 5000, 10000],
    [1000, 1500, 3000, 5000, 10000],
  ]

  return () => {
    const bucketIndex = Math.floor(Math.random() * buckets.length)
    return buckets[bucketIndex]
  }
})()
